import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {Moment} from 'moment';
import {BirthDateUtils} from '../../../../../shared/utils/birthdate.utils';

@Component({
  selector: 'app-age-label',
  templateUrl: './age-label.component.html',
})
export class AgeLabelComponent implements OnChanges {

  @Input() date: Moment;
  age = -1;
  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['date']) {
      this.age = -1;
      if (this.date) {
        this.age = BirthDateUtils.calculateAge(this.date);
      }
    }
  }

}
